// REACT
import { useEffect, useState, useContext } from "react";

// ASSETS
import { Button, Spinner, Alert, ListGroup } from "react-bootstrap";
import { FaDownload } from "react-icons/fa";
import languagePack from "../../assets/languages/languagePack";
import "../../assets/styles/templates.css";

// HOOKS
import { useRead } from "../../hooks/useFetch";

// CONTEXT
import { maincontext } from "../../context/maincontext";

export default function TemplateList({
    fetchUrl,
    onDownload,
    isDownloadingFile,
    downloadError
}) {
    const { language } = useContext(maincontext);

    // List of template file names
    const [templates, setTemplates] = useState(null);

    // Fetch template file names
    const { data: listData, isPending: isFetching, error: fetchError } = useRead(fetchUrl, null);

    // Error states
    const [error, setError] = useState(null);

    useEffect(() => {
        if (listData && Array.isArray(listData)) {
            setTemplates(listData);
            setError(null);
        } else if (fetchError) {
            setError(languagePack[language].templatelist.templateFetchError);
        }

        // eslint-disable-next-line
    }, [listData, fetchError]);

    return (
        <div className="template-list mt-5">
            <h5>{languagePack[language].templatelist.templateTitle}</h5>
            {isFetching && (
                <div className="d-flex justify-content-center mt-2">
                    <Spinner animation="border" size="sm" />
                </div>
            )}
            {error && <Alert variant="danger" className="mt-2">{error}</Alert>}
            {downloadError && <Alert variant="danger" className="mt-2">{downloadError}</Alert>}

            {/* Show custom empty state message */}
            {!isFetching && (templates?.length === 0 || templates === null) && !error && (
                <Alert variant="info" className="mt-3">
                    {languagePack[language].templatelist.noTemplates}
                </Alert>
            )}
            {!isFetching && !fetchError && templates !== null && templates?.length > 0 ?
                <ListGroup className="mt-3 template-list-wrapper">
                    {templates.map((filename) => (
                        <ListGroup.Item
                            key={filename}
                            className="d-flex justify-content-between align-items-center"
                        >
                            {filename}
                            <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => onDownload(filename)}
                                className="template-download-btn"
                                disabled={isDownloadingFile === filename}
                            >
                                {isDownloadingFile === filename ? (
                                    <Spinner animation="border" size="sm" />
                                ) : (
                                    <FaDownload className="download-icon" />
                                )}
                            </Button>
                        </ListGroup.Item>
                    ))}
                </ListGroup> : null
            }
        </div>
    );
}
